import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListCaveatTypesActions } from "store/ducks/settings/caveat-types";

import { CaveatType } from "interfaces/caveat-type";

export function* listCaveatTypesRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/indent-caveat-types?${queryString}`);
    const comboOptions = data.map((caveatType: CaveatType) => ({
      value: caveatType.id,
      label: caveatType.name,
    }));

    yield put(ListCaveatTypesActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListCaveatTypesActions.failure(errorMessage));
  }
}
